import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Empty, EmptyDescription, EmptyHeader, EmptyTitle } from "@/components/ui/empty";
import { InformationSentNotice, ResellerInformationForm } from "@/features/reseller/form-reseller-profile/form";
import { informationQuery } from "@/features/reseller/queries";
import { StandingNotice } from "@/features/reseller/standing-notice";
import { m } from "@/lib/paraglide/messages.js";

// A pending reseller's information is only fetched while it is pending: nothing else on this
// page needs it.
export const Route = createFileRoute("/_authenticated/dashboard/")({
  loader: ({ context }) =>
    context.reseller.status === "pending" ? context.queryClient.ensureQueryData(informationQuery()) : undefined,
  staticData: { crumb: m.portal_dashboard },
  component: Dashboard,
});

/**
 * Asks for the information until it was sent; after that only the notice is left, and the profile
 * page has it. Right after sending, a confirmation too: page state, so leaving the page ends it.
 */
function PendingDashboard() {
  const { data: sent } = useSuspenseQuery(informationQuery());
  const [justSent, setJustSent] = useState(false);
  return (
    <div className="flex flex-col gap-6">
      <StandingNotice status="pending" />
      {justSent && <InformationSentNotice />}
      {!sent && <ResellerInformationForm onSent={() => setJustSent(true)} />}
    </div>
  );
}

function Dashboard() {
  const { reseller } = Route.useRouteContext();
  if (reseller.status === "pending") return <PendingDashboard />;
  if (reseller.status !== "active") return <StandingNotice status={reseller.status} />;
  return (
    <Empty>
      <EmptyHeader>
        <EmptyTitle>{m.portal_dashboard()}</EmptyTitle>
        <EmptyDescription>{m.portal_dashboard_empty()}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
